// extracted by mini-css-extract-plugin
module.exports = {"bank-card-preview":"bank-card-preview--3lQl7aci1f","bankCardPreview":"bank-card-preview--3lQl7aci1f","bank-name":"bank-name--qj1K-4TmEH","bankName":"bank-name--qj1K-4TmEH"};